
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { backpackOpenType, backpackUpdataDialog } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, normalBackPackSaveI, normalBackPackSaveMap, NormalBackpackType } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatPeople } from "../../manager/WeChatConst";
import backpackBtnLayout from "./backpackBtnLayout";
import BackpackInfoLayer from "./BackpackInfoLayer";
import BackpackItem from "./BackpackItem";
import BackpackMenu from "./BackpackMenu";
import backpackStallPrfab from "./backpackStallPrefab";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BackpackPrefab extends cc.Component {

	@property({ type: cc.Node, displayName:'' })
	nodeInfo: cc.Node = null;

    @property({ type: cc.Node, displayName: "背包页面" })
    backpackContent: cc.Node = null;

    @property({ type: cc.Prefab, displayName: "背包item" })
    backpackItem: cc.Prefab = null;

    @property({ type: cc.Node, displayName: "物品信息菜单" })
    backpackMenu: cc.Node = null;

    @property({type:cc.Node,displayName:"物品用途layout"})
    backpackUseLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"空空如也节点"})
    kongNode:cc.Node = null;

    @property({type:cc.Prefab,displayName:"赠送预制体"})
    stallPrefab:cc.Prefab = null;

    @property({type:cc.ScrollView,displayName:"滚动视图"})
    scrollView:cc.ScrollView = null;

    // @property({type:cc.Node,displayName:"按钮Layout"})
    // btnLayout:cc.Node = null;

    @property([cc.Node])
    btnNodeList: cc.Node[] = [];

    gameManager: NormalGameManager;
    backpack: normalBackPackSaveMap = <normalBackPackSaveMap>{};
    goodsID: number;

    openType:backpackOpenType = backpackOpenType.normal;

    private nodeInfoScript: BackpackInfoLayer = null;

    successFun:(item:NormalBackpackI, count?: number)=>void = null;
    failFun:(item:NormalBackpackI)=>void = null;
    autoRuleFun:(item:NormalBackpackI)=>boolean = null;
    start() {
        O1HD.getModules().uiControlModule.hideLoading();
        this.nodeInfo.active = false;
        this.nodeInfoScript = this.nodeInfo.getChildByName('BackpackInfoLayer').getComponent(BackpackInfoLayer);
        this.gameManager = NormalGameManager._instance;
        this.backpack = this.gameManager.getGameData().backpack;
        this.onShowGoods(null,this.currentShowType,false,this.autoRuleFun);
        O1HD.on(backpackUpdataDialog,this.onShowGoods,this);
    }

    bindData(
        openType:backpackOpenType = backpackOpenType.normal
        , showType:NormalBackpackType
        , successFun:(item:NormalBackpackI, count?: number)=>void = null
        , failFun:(item:NormalBackpackI)=>void = null
        , autoRuleFun?:(item:NormalBackpackI)=>boolean
        
    ) {
        this.currentShowType = showType;
        this.openShowType = showType;
        this.openType = openType;
        this.successFun = successFun;
        this.autoRuleFun = autoRuleFun;
        this.failFun = failFun;
    }

    showExplain(item:BackpackItem) {
        this.backpackMenu.active = true;
        let backSaveItem = item.backpackItem;
        let backItem = backPackEventMap()[backSaveItem.backId];
        let explain = backItem.details;
        this.backpackMenu.getComponent(BackpackMenu).bindData(explain);
        let node:cc.Node = item.node;
        let scorllNode:cc.Node = this.scrollView.node;
        let pos:cc.Vec2 = scorllNode.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2()));
        let width = this.backpackMenu.width;
        let menuX:number = 0;
        let menuY:number = 0;
        if(node.x > 0){
            menuX = pos.x - width;
            menuY = pos.y;
        }else{
            menuX = pos.x;
            menuY = pos.y;
        }
        this.backpackMenu.x = menuX;
        this.backpackMenu.y = menuY;
        this.showExplainY = menuY;
        this.explainOffsetY = this.scrollView.getScrollOffset().y;
    }

    hideExplain(){
        this.backpackMenu.active = false;
    }

    currentItem:BackpackItem = null;
    explainOffsetY:number = null;
    btnOffsetY:number = null;

    showExplainY:number = null;
    showBtnLayoutY:number = null;

    currentShowType:NormalBackpackType = null;
    openShowType:NormalBackpackType = null;

    async showUseBtns(item:BackpackItem){
        switch(this.openType){
            case backpackOpenType.select:{
                if (item.goodsConfig.bNotSellSend) {
                    O1HD.getModules().uiControlModule.showMessageBox("物品不可被选择");
                    return;
                }
                this.successFun && this.successFun(item.goodsConfig);
                this.onClose();
                return;
            }
            case backpackOpenType.selectCount:{
                if (item.goodsConfig.bNotSellSend) {
                    O1HD.getModules().uiControlModule.showMessageBox("物品不可被选择");
                    return;
                }
                let goodsData = this.gameManager.getOneGood(item.goodsID);
                let selectGoodsCount = 1;
                if (goodsData && goodsData.num > 1) {
                    await new Promise<void> ((resolve)=> {
                        utilsView.openPopupLayerTwo(
                            FileKind.PrefabFilePath.PacksackSellLayer
                            , null
                            , {
                                goodsId: item.goodsID
                                , confirm: (selectNum: number)=> {
                                    selectGoodsCount = selectNum;
                                    resolve();
                                }
                                , cancel: ()=> {
                                    selectGoodsCount = 0;
                                    resolve();
                                }
                                , hideSellPrice: true
                            }
                        );
                    })
                    if (selectGoodsCount <= 0) {
                        this.failFun && this.failFun(item.goodsConfig);
                        this.onClose();
                        return;
                    }
                } 
                this.successFun && this.successFun(item.goodsConfig, selectGoodsCount);
                this.onClose();
                return;
            }
            case backpackOpenType.stall:{
                if(item.backpackItem.isSell){
                    O1HD.getModules().uiControlModule.showMessageBox("正在出售中")
                    return;
                }
                this.successFun && this.successFun(item.goodsConfig);
                this.onClose();
                return;
            }
        }
        if(this.currentItem?.uuid == item.uuid){
            // this.currentItem = null;
            // this.hideUseBtns();
            // return;
        }
        
        this.currentItem = item;
        let node:cc.Node = item.node;
        // let scorllNode:cc.Node = this.scrollView.node;
        // let pos:cc.Vec2 = scorllNode.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2()));
        // let layoutX:number = pos.x;
        // let layoutY:number = pos.y - (node.height / 2);
        // this.backpackUseLayout.x = layoutX;
        // this.backpackUseLayout.y = layoutY;
        // this.showBtnLayoutY = layoutY;
        // this.btnOffsetY = this.scrollView.getScrollOffset().y;

        this.nodeInfo.active = true;
        this.nodeInfoScript.showUI(this, item.backpackItem, node);
        // this.backpackUseLayout.getComponent(backpackBtnLayout).bindData(item.backpackItem);
    }

    hideUseBtns(){
        this.nodeInfo.active = false;
        this.backpackUseLayout.getComponent(backpackBtnLayout).hideAni();
    }

    onMoveMenu(){
        let offsetY = this.scrollView.getScrollOffset().y;

        let explainCurrentOffsetY = this.explainOffsetY - offsetY;
        this.backpackMenu.y = this.showExplainY - explainCurrentOffsetY;

        let btnCurrentOffsetY = this.btnOffsetY - offsetY;
        this.backpackUseLayout.y = this.showBtnLayoutY - btnCurrentOffsetY;

    }

    onCloseMenu() {
        this.backpackMenu.active = false;
    }

    onClose() {
        //把玩家选中的物品ID通过回调传出去
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.destroy();
    }

    onLock() {
        O1HD.getModules().uiControlModule.showMessageBox("未解锁");
    }

    async onShowGoods(
        e: cc.Event.EventTouch
        , type: NormalBackpackType
        , bForceUpdate: boolean = false,autoRule?:(obj:NormalBackpackI)=>boolean
    ) {
        // if (this.backpackMenu.active) {
        //     this.backpackMenu.active = false;
        // }
        let bNotSellSend = this.openType == backpackOpenType.select || this.openType == backpackOpenType.selectCount;
        this.currentShowType = type;
        this.updateBtns();
        let length = 0;
        for(let k in this.backpack){
            let backAryObj = this.backpack[k];
            let backObj = backPackEventMap()[backAryObj.backId];
            if(autoRule && !autoRule(backObj)){
                continue;
            }
            if(!backObj){
                continue;
            }
            if (bNotSellSend && backObj.bNotSellSend) {
                continue;
            }
            if ( type == null || backObj?.type?.includes(type)) {
                length ++;
            }
        }

        let itemCount:number = this.backpackContent.childrenCount;
        let needItem:number = length - itemCount;
        if(bForceUpdate || needItem>0){
            await O1HD.getModules().uiControlModule.showLoading(null,"正在加载背包数据");
            for(let i =0;i<needItem;i++){
                await new Promise<void>(resolve=>{
                    let node:cc.Node = cc.instantiate(this.backpackItem);
                    node.setParent(this.backpackContent);
                    this.scheduleOnce(resolve);
                });
            }
            O1HD.getModules().uiControlModule.hideLoading();
        }else{
            // let hideCount:number = Math.abs(needItem);
            // for(let i = 0;i<hideCount;i++){
            //     let cNode = this.backpackContent.children[this.backpackContent.childrenCount - hideCount - 1];
            //     if(cNode){
            //         cNode.active = false;
            //     }
            // }
            this.backpackContent.children.forEach((n:cc.Node)=>{
                n.active = false;
            });
            
            this.currentItem = null;
            this.hideUseBtns();
        }

        
        // this.backpackContent.removeAllChildren();
        let nIndex:number = 0;
        for(let k in this.backpack){
            let backAryObj = this.backpack[k];
            let backObj = backPackEventMap()[backAryObj.backId];
            if(!backObj){
                continue;
            }
            if (bNotSellSend && backObj.bNotSellSend) {
                continue;
            }
            if (type == null || backObj?.type?.includes(type)) {
                this.kongNode.active = false;
                let item = this.backpackContent.children[nIndex];
                item.active = true;
                item.getComponent(BackpackItem).bindData(this.backpack[k],this ,this.onMoveMenu.bind(this));
                nIndex ++;
            }
        }
    }

    onBtnLayoutBtn(e:cc.Event.EventTouch,custom:string){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let index:number = Number(custom);
        let type:number = this.currentItem.goodsConfig.interactionType[index];
        switch(type){
            case 0:{
                this.onBtnStall();
                break;
            }
            case 1:{
                this.onBtnUse(e.target);
                break;
            }
            case 2:{
                this.onBtnGive();
                break;
            }
        }
    }

    onOutGoods() {
        this.gameManager.onOutGoods(this.goodsID);
        this.onShowGoods(null,this.currentShowType);
    }

    onBtnUse(node: cc.Node){
        let useItem = this.currentItem;
        let backItemId = useItem.backpackItem;
        let backId = backItemId.backId;
        let backItem = backPackEventMap()[backId];
        let self = this;
        this.gameManager.backpackManager.checkVaildUseOrGiveRule(
            backItem
            , null
            , (useItem2) => {
                if (!self.node || !cc.isValid(self.node)) {
                    return;
                }
                if (useItem && useItem.backpackItem.num > 0) {
                    this.showUseBtns(this.currentItem);
                    this.currentItem.refreshCount();
                } else {
                    this.hideUseBtns();
                    this.onShowGoods(null,this.currentShowType);
                }
                
                this.successFun && this.successFun(useItem2);
            }
            , this.failFun
            , node
        );
    }

    updateBtns(){
        let strAry:string[] = [
            "物品",
            this.openShowType
        ];

        

        this.btnNodeList.forEach((n:cc.Node,index:number)=>{
            let bg = n.getChildByName("bg");
            let suo = n.getChildByName("suo");
            let labelNode = n.getChildByName("label");
            let label = labelNode.getComponent(cc.Label);
            label.string = strAry[index] ? strAry[index] : "" ;
            switch(this.currentShowType){
                case undefined:
                case null:{
                    if(index == 0){
                        bg.active = false;
                        suo.active = false;
                    }else{
                        bg.active = true;
                        suo.active = true;
                    }
                    break;
                }
                default:{
                    if(index != 1){
                        bg.active = true;
                        suo.active = true;
                    }else{
                        bg.active = false;
                        suo.active = false;
                    }
                    break;
                }
            }
            n.getComponent(cc.Button).interactable = suo.active;
            n.zIndex = suo.active ? 0 : 1;
        });
    }
    
    onBtnOne(){
        this.onShowGoods(null,null);
    }

    onBtnTwo(){
        if(this.openShowType){
            this.onShowGoods(null,this.openShowType);
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("暂未开放");    
        }
    }

    onBtnThree(){
        O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
    }

    onBtnStall(){

    }

    async onBtnGive(){
        let useItem = this.currentItem;
        let backItemId = useItem.backpackItem;
        let backId = backItemId.backId;
        let backItem = backPackEventMap()[backId];
        let giveNode = cc.instantiate(this.stallPrefab);
        giveNode.setParent(O1HD.Canvas());
        let gs = giveNode.getComponent(backpackStallPrfab);
        let complateFun = (npc:WeChatPeople)=>{
            this.gameManager.backpackManager.checkVaildUseOrGiveRule(backItem,npc.name,this.successFun,this.failFun);
        }
        gs.bindComplete(complateFun.bind(this));
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal","backpack");
    }
}
